import { ILocationSearchItemFragment } from 'transfix-maps/hooks/useLocationSearch'
import { ILocationSuggestion } from 'transfix-ui/components/SuggestLocation'

export type TGetResultLabelFunc = (result: ILocationSearchItemFragment) => string

interface IGetMappedResultsOptions {
  /**
   * @example ({ city, state }) => [city, state].join(', ')
   */
  getResultLabel?: TGetResultLabelFunc
}

/**
 * @returns 'New York, New York, United States'
 */
const getDefaultResultLabel: TGetResultLabelFunc = ({ city, country, state }) => {
  return [city, state, country].filter(Boolean).join(', ')
}

/**
 * Returns an array of `MapboxSuggestion` type for use with legacy implementations
 */
export const getMappedResults = (
  results: ILocationSearchItemFragment[],
  options: IGetMappedResultsOptions = {}
): ILocationSuggestion[] => {
  const { getResultLabel = getDefaultResultLabel } = options || {}
  return results.map(result => {
    const {
      address,
      city,
      coordinates,
      country,
      countryCode,
      id,
      latitude,
      longitude,
      postalCode,
      resultType,
      state,
      stateCode,
    } = result || {}
    const placeName = getResultLabel(result)
    return {
      postalCode: postalCode ?? '',
      city: city ?? '',
      placeName: placeName ?? '',
      id: id ?? '',
      label: placeName ?? '',
      addressLine1: address ?? '',
      coordinates,
      resultType: resultType ?? '',
      state: state ?? '',
      stateCode: stateCode ?? '',
      country: country ?? '',
      countryCode: countryCode ?? '',
      latitude,
      longitude,
    }
  })
}
